import { m } from '@sohanscript/i18n';
import { SrOnly } from '@sohanscript/ui/sr-only';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/trpc/client';
import { NoteCard } from './note-card';

export function NotesPreview() {
	const [notes] = api.note.homepage.useSuspenseQuery();

	if (!notes?.length) return null;

	return (
		<div className="flex flex-col items-center gap-12">
			<div className="container w-full space-y-5 md:columns-2 md:px-8">
				{notes.map((note) => (
					<NoteCard key={note.slug?.current} {...note} initial="hidden" />
				))}
			</div>
			<Button icon="solar:document-add-linear" variant="hover" href="/notes">
				{m.notes_read_more()}
				<SrOnly>{m.notes_read_more_desc()}</SrOnly>
			</Button>
		</div>
	);
}
